/* RESPONSIBLE TEAM: team-messenger */
export function formattedTimezone(timeZone) {
  return timeZone.slice(timeZone.lastIndexOf('/') + 1).replace(/_/g, ' ');
}
